import { makeStyles } from "@mui/styles";
import { FLEX_CONSTANTS } from "../../constants/StyleConstants";

const LayoutStyles = makeStyles((theme) => ({
  logoHeader: {
    display: FLEX_CONSTANTS.FLEX,
    flex: 1,
    justifyContent: FLEX_CONSTANTS.CENTER,
    alignItems: FLEX_CONSTANTS.CENTER,
    paddingTop: theme.paddings.xl,
    paddingBottom: theme.paddings.xl
  }
}));

export default LayoutStyles;
